import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = { class: "d-flex flex-stack" }
const _hoisted_3 = { class: "m-0 text-white fw-bolder fs-3" }
const _hoisted_4 = { class: "ms-1 d-none" }
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_7 = { class: "fw-bold fs-7" }
const _hoisted_8 = { class: "fw-bolder fs-4x" }
const _hoisted_9 = {
  key: 0,
  class: "shadow-xs card-rounded mx-4 mb-2 px-6 py-6 position-relative z-index-1 bg-white",
  style: {"margin-top":"-100px"}
}
const _hoisted_10 = { class: "symbol symbol-40px w-35px me-5" }
const _hoisted_11 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_12 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_13 = { class: "fs-5 text-gray-800 text-hover-primary fw-bolder" }
const _hoisted_14 = {
  key: 0,
  class: "text-gray-400 fw-bold fs-7"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "fw-bolder fs-5 badge badge-light-primary badge-circle" }
const _hoisted_17 = {
  key: 0,
  class: "svg-icon svg-icon-5 svg-icon-success ms-1"
}
const _hoisted_18 = {
  key: 1,
  class: "svg-icon svg-icon-5 svg-icon-danger ms-1"
}
const _hoisted_19 = {
  key: 2,
  class: "d-flex flex-wrap"
}
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "fs-2 fw-bold" }
const _hoisted_22 = { class: "fw-semobold fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([`bg-${_ctx.widgetColor}`, "px-9 pt-6 card-rounded h-275px w-100"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.widgetTitle), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass([`btn-active-color-${_ctx.widgetColor}`, "btn btn-sm btn-icon btn-color-white btn-active-white border-0 me-n3"]),
              "data-kt-menu-trigger": "click",
              "data-kt-menu-placement": "bottom-end",
              "data-kt-menu-flip": "top-end"
            }, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen024.svg" })
              ])
            ], 2),
            _createVNode(_component_Dropdown3)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('acrd12')), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.widgetAmount), 1)
        ])
      ], 2),
      (_ctx.itemsList.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "d-flex align-items-center mb-3"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", {
                    class: _normalizeClass(`symbol-label bg-${item.params}`)
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", _hoisted_13, _toDisplayString(item.name), 1),
                    (item.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.quantity), 1),
                    (item.arrow === 'up')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                        ]))
                      : (item.arrow === 'down')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr065.svg" })
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            "image-size": 50,
            description: "Sin resultados"
          })),
      (_ctx.itemsTwo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTwo, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "border border-gray-500 border-dashed rounded col py-3 px-4 m-4 mb-3 shadow"
              }, [
                _createElementVNode("div", _hoisted_20, [
                  (item.params)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(`${item.params} fs-1 me-2`)
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(item.quantity), 1)
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(item.name), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2)), [
    [_directive_loading, _ctx.loading]
  ])
}